// Phase 11 — Tasks module hook.
import { useQuery } from '@tanstack/react-query';

interface TaskEntry { id: string; title: string; description: string; priority: string; status: string; due_date: string | null; project: string; recurring: string; created_at: string; updated_at: string; }

export function useTasks() {
  return useQuery<TaskEntry[]>({
    queryKey: ['tasks', 'entries'],
    queryFn: async () => {
      const res = await fetch('/api/modules/tasks/entries', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to load tasks');
      return res.json();
    },
    staleTime: 30_000,
  });
}
